<i18n src="@/locales/models/delivery_collection.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/delivery_collection_item.yml" lang="yaml"></i18n>
<i18n
  src="@/locales/views/service_provider/delivery/managing/show_delivery_collection.yml"
  lang="yaml"
></i18n>

<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    :name="routeName('show_process_delivery_collections')"
    :params="{
      service_provider_id: service_provider_id,
      delivery_process_id: delivery_process_id
    }"
  />

  <bread-crumbs
    :labels="[
      module_name,
      delivery_process?.name,
      delivery_collection?.collection_code
    ]"
  />

  <template v-if="load_general_data">
    <div class="mt-8">
      <div class="panel">
        <div class="panel-header">
          <h3 class="panel-header-title">
            {{ $t("labels.title") }}
          </h3>
        </div>

        <div class="panel-body">
          <div class="space-y-8 divide-y divide-gray-200">
            <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.delivery_collection.collection_code") }}
                </dt>
                <dd class="content-data">
                  {{ delivery_collection.collection_code }}
                </dd>
              </div>

              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.delivery_collection.collected_at") }}
                </dt>
                <dd class="content-data">
                  {{ dateFormatter(delivery_collection.collected_at) }}
                </dd>
              </div>

              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.delivery_collection.delivery_employee") }}
                </dt>
                <dd class="content-data">
                  {{ delivery_collection.user.name }}
                </dd>
              </div>
            </div>

            <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6 pt-4">
              <div
                v-for="delivery_process_attribute in collectionAttributes"
                :key="delivery_process_attribute.id"
                class="sm:col-span-3"
              >
                <dt class="label-data">
                  {{ delivery_process_attribute.label }}
                </dt>
                <dd class="content-data">
                  {{
                    deliveryProcessValue(
                      delivery_process_attribute.id
                    )
                  }}
                </dd>
              </div>
            </div>

            <div class="panel">
              <div class="panel-header">
                <h3 class="panel-header-title">
                  {{ $t("labels.items") }}
                </h3>
              </div>
              <div class="panel-body">
                <div class="space-y-8 divide-y divide-gray-200">
                  <div
                    v-for="(
                      delivery_collection_item, index
                    ) in delivery_collection.delivery_collection_items"
                    class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6"
                    :key="index"
                  >
                    <div class="sm:col-span-3">
                      <dt class="label-data">
                        {{
                          $t("model.delivery_collection_item.delivery_product")
                        }}
                      </dt>
                      <dd class="content-data">
                        {{
                          delivery_collection_item.delivery_product.crop.name
                        }}
                        ({{
                          delivery_collection_item.delivery_product
                            .unit_of_measure
                        }})
                      </dd>
                    </div>

                    <div class="sm:col-span-3">
                      <dt class="label-data">
                        {{ $t("model.delivery_collection_item.quantity") }}
                      </dt>
                      <dd class="content-data">
                        {{ delivery_collection_item.quantity }}
                      </dd>
                    </div>

                    <div class="sm:col-span-3">
                      <dt class="label-data">
                        {{
                          $t(
                            "model.delivery_collection_item.delivery_process_provider"
                          )
                        }}
                      </dt>
                      <dd class="content-data">
                        {{
                          delivery_collection_item.delivery_process_provider
                            .name
                        }}
                      </dd>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
</template>

<script>
import Requester from "@/views/service_provider/requesters/delivery/managing/show_delivery_collection.js";
export default {
  name: "SPDeliveryDistributionShowDeliveryCollection",
  data() {
    return {
      load_general_data: false,
      proc_button_destroy: false,
      delivery_process: {},
      delivery_collection: {}
    };
  },
  props: {
    service_provider_id: { required: true },
    delivery_process_id: { required: true },
    id: { required: true }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          service_provider_id: this.service_provider_id
        }
      }).then(() => this.loadData())
    );
  },
  computed: {
    collectionAttributes() {
      return this.delivery_process.delivery_process_attributes.filter(
        (attr) => attr.use_in_collections
      );
    }
  },
  methods: {
    loadData: async function () {
      await this.fetchDeliveryProcess();
      await this.fetchDeliveryCollection();
      this.load_general_data = true;
    },

    fetchDeliveryProcess: async function () {
      const response = await Requester.fetchDeliveryProcess(
        this.service_provider_id,
        this.delivery_process_id
      );

      this.delivery_process = response.data;
    },

    fetchDeliveryCollection: async function () {
      const response = await Requester.fetchDeliveryCollection(
        this.service_provider_id,
        this.delivery_process_id,
        this.id
      );

      this.delivery_collection = response.data;
    },
    deliveryProcessValue(delivery_process_attribute_id) {
      return this.delivery_collection.delivery_attribute_values?.find(
        (value) =>
          value.delivery_process_attribute_id === delivery_process_attribute_id
      )?.label_value || "";
    },
  },
  watch: {}
};
</script>
